module.exports = __webpack_public_path__ + "img/no_data.34f622de.svg";